module.exports = __webpack_public_path__ + "static/img/10006.00e03a91.png";